export var getComposeItemId = function (viewState) { return function () {
    return viewState.itemId ? viewState.itemId.Id : null;
}; };
export var getReadItemId = function (item) { return function () {
    return item.ItemId.Id;
}; };
//# sourceMappingURL=ItemIdAdapter.js.map